/*
 * SlingoConstants.ts
 */
export class SlingoConstants {
    ;
}
SlingoConstants.CURRENT_SPIN_PRICE = "purchaseStake";
SlingoConstants.NEXT_SPIN_PRICE = "nextPurchaseStake";
SlingoConstants.PROPERTY_ACTIONS = "actions";
SlingoConstants.PROPERTY_ACCOUNT_BALANCE = "balance";
SlingoConstants.PROPERTY_AMOUNT = "amount";
SlingoConstants.PROPERTY_BALANCE = "balance";
SlingoConstants.PROPERTY_INITIAL_BALANCE = "initialResponseBalance";
SlingoConstants.PROPERTY_BASE_PAYOUT = "basePayout";
SlingoConstants.PROPERTY_BONUS_INDEXES = "bonusIndexes";
SlingoConstants.PROPERTY_CELEBRATE_WIN_THRESHOLD = "celebrateWinThreshold";
SlingoConstants.PROPERTY_CELL_NUMBER = "cellNumber";
SlingoConstants.PROPERTY_CLIENT = "client";
SlingoConstants.PROPERTY_COIN_INDEXES = "coinIndexes";
SlingoConstants.PROPERTY_COLLECTABLE_INDEXES = "collectableIndexes";
SlingoConstants.PROPERTY_COMPLETE_REASON = "completionReason";
SlingoConstants.PROPERTY_CONFIG = "config";
SlingoConstants.PROPERTY_CURRENCY = "currencyCode";
SlingoConstants.PROPERTY_DEVIL_INDEXES = "devilIndexes";
SlingoConstants.PROPERTY_FREE_GAME_STAKE = "nextFreeGameStake";
SlingoConstants.PROPERTY_FREE_GAMES_REMAINING = "totalFreeGamesAvailable";
SlingoConstants.PROPERTY_FREE_SPIN_INDEXES = "freeSpinIndexes";
SlingoConstants.PROPERTY_FREE_SPINS_AWARDED = "freeSpinsAwarded";
SlingoConstants.PROPERTY_FREE_SPINS = "freeSpins";
SlingoConstants.PROPERTY_FREE_SPINS_USED = "freeSpinsUsed";
SlingoConstants.PROPERTY_FREE_SPINS_REMAINING = "freeSpinsRemaining";
SlingoConstants.PROPERTY_GAME_CONFIG = "gameConfig";
SlingoConstants.PROPERTY_SPIN_TYPE = "spinType";
SlingoConstants.PROPERTY_GAME_ID = "gid";
SlingoConstants.PROPERTY_GAME_INSTANCE_ID = "gameInstanceId"; //"giid";
SlingoConstants.PROPERTY_GAME_PROGRESS = "gameProgress";
SlingoConstants.PROPERTY_HAS_CHERUB = "hasCherub";
SlingoConstants.PROPERTY_MATCHED_NUMBERS = "matchedNumbers";
SlingoConstants.PROPERTY_MESSAGE_ACKNOWLEDGED = "msgAcknowledged";
SlingoConstants.PROPERTY_ID = "id";
SlingoConstants.PROPERTY_IS_FIRST_PURCHASE_SPIN = "hasFirstPurchaseSpin";
SlingoConstants.PROPERTY_IS_FREE_GAME = "isFreeGame";
SlingoConstants.PROPERTY_JOKER_CELLS = "jokerCells";
SlingoConstants.PROPERTY_JOKER_INDEXES = "jokerIndexes";
SlingoConstants.PROPERTY_LAST_STAKE = "lastStake";
SlingoConstants.PROPERTY_MATCHED_PATTERNS = "matchedPatterns";
SlingoConstants.PROPERTY_MINIMUM_SPIN_DURATION = "minimumSpinDuration";
SlingoConstants.PROPERTY_MODIFIER = "modifier";
SlingoConstants.PROPERTY_MULTIPLIER = "multiplier";
SlingoConstants.PROPERTY_MULTIPLIERS = "multipliers";
SlingoConstants.PROPERTY_NUMBER_OF_COLUMNS = "columns";
SlingoConstants.PROPERTY_NUMBER_OF_PATTERNS = "numberOfPatterns";
SlingoConstants.PROPERTY_NUMBER_OF_PURCHASE_SPINS = "purchaseSpins";
SlingoConstants.PROPERTY_NUMBER_OF_ROWS = "rows";
SlingoConstants.PROPERTY_NUMBER_OF_SPINS = "standardSpins"; //"numberOfSpins";
SlingoConstants.PROPERTY_NUMBER_OF_SYMBOLS = "numberOfSymbols";
SlingoConstants.PROPERTY_PATTERN = "pattern";
SlingoConstants.PROPERTY_PATTERNS = "patterns";
SlingoConstants.PROPERTY_PATTERN_WIN = "patternWin";
SlingoConstants.PROPERTY_PAYOUT_CONFIG = "payoutConfig";
SlingoConstants.PROPERTY_PRIZE_CONFIG = "prizeConfig";
SlingoConstants.PROPERTY_PURCHASABLE_SPINS_AVAILABLE = "purchaseSpins"; //"purchaseableSpinsAvailable"
SlingoConstants.PROPERTY_PURCHASABLE_SPINS_REMAINING = "purchaseSpinsRemaining"; //"purchaseableSpinsRemaining"
SlingoConstants.PROPERTY_PURCHASE_SPINS_USED = "purchaseSpinsUsed";
SlingoConstants.PROPERTY_REEL_SEQUENCE = "reelSequence";
SlingoConstants.PROPERTY_SPINS = "spins";
SlingoConstants.PROPERTY_SPINS_REMAINING = "standardSpinsRemaining"; // "spinsRemaining";
SlingoConstants.PROPERTY_SPIN_PRICE = "spinPrice";
SlingoConstants.PROPERTY_SPIN_RESULT = "spinResult";
SlingoConstants.PROPERTY_SPIN_RESULTS = "spinResults";
SlingoConstants.PROPERTY_STAKE_CONFIG = "stakeConfig";
SlingoConstants.PROPERTY_STANDARD_SPINS = "standardSpins";
SlingoConstants.PROPERTY_STANDARD_SPINS_USED = "standardSpinsUsed";
SlingoConstants.PROPERTY_SUPER_JOKER_CELLS = "superJokerCells";
SlingoConstants.PROPERTY_SUPER_JOKER_INDEXES = "superJokerIndexes";
SlingoConstants.PROPERTY_SYMBOL = "symbol";
SlingoConstants.PROPERTY_SYMBOL_CONFIG = "symbolConfig";
SlingoConstants.PROPERTY_SYMBOLS = "symbols";
SlingoConstants.PROPERTY_TOTAL_WIN = "totalWin";
SlingoConstants.PROPERTY_STANDARD_WIN = "standardWin";
SlingoConstants.PROPERTY_SYMBOL_WIN = "symbolWin";
SlingoConstants.PROPERTY_SYMBOL_WINS = "symbolWins";
SlingoConstants.PROPERTY_TICKET = "ticket";
SlingoConstants.PROPERTY_TICKET_DATA = "data";
SlingoConstants.PROPERTY_TICKET_ID = "ticketId";
SlingoConstants.PROPERTY_TOTAL_SPINS = "totalSpins";
SlingoConstants.PROPERTY_WRAPPER = "wrapper";
SlingoConstants.PROPERTY_PATTERN_PAYOUTS = "patternPayouts";
SlingoConstants.PROPERTY_RECOVERY = "recovery";
SlingoConstants.PROPERTY_ROOM_NAME = "rn";
SlingoConstants.PROPERTY_STAKE_AMOUNT = "stakeAmount";
SlingoConstants.PROPERTY_STAKE_AMOUNTS = "amounts";
SlingoConstants.PROPERTY_STAKE_DEFAULT_INDEX = "defaultIndex";
SlingoConstants.PROPERTY_STATE = "state";
SlingoConstants.PROPERTY_SYMBOL_PAYOUTS = "symbolPayouts";
SlingoConstants.PROPERTY_TYPE = "type";
SlingoConstants.PURCHASE_SPIN_TOTAL_STAKED = "purchaseStake";
SlingoConstants.PROPERTY_TOTAL_STAKED = "totalStake";
SlingoConstants.PROPERTY_STANDARD_STAKE = "standardStake";
SlingoConstants.PROPERTY_FEATURE = "feature";
SlingoConstants.PROPERTY_CHANCE_GAMES = "chanceGames";
SlingoConstants.PROPERTY_SLOTS_GAME = "slotsGame";
SlingoConstants.PROPERTY_SLOTS_SPINS = "slotsSpins";
SlingoConstants.PROPERTY_NEXT_STAKE_TO_SPIN = "nextStakeToSpin";
SlingoConstants.PROPERTY_STAKE_TO_SPIN = "stakeToSpin";
SlingoConstants.PROPERTY_NEXT_STAKE_TO_SPIN_CHANCE = "nextStakeToSpinChance";
SlingoConstants.PROPERTY_TOTAL_NEXT_STAKE_TO_SPIN = "totalNextStakeToSpin";
SlingoConstants.PROPERTY_TOTAL_STAKE_TO_SPIN = "totalStakeToSpin";
SlingoConstants.PROPERTY_MAXIMUM_STAKE_TO_SPIN_ATTEMPTS = "maximumStakeToSpinAttempts";
SlingoConstants.PROPERTY_MINIMUM_STAKE_TO_SPIN_CHANCE = "minimumStakeToSpinChance";
SlingoConstants.PROPERTY_STAKE_TO_SPIN_ENABLED = "stakeToSpinEnabled";
SlingoConstants.PROPERTY_STAKE = "stake";
SlingoConstants.PROPERTY_WIN = "win";
SlingoConstants.PROPERTY_RNG = "rng";
SlingoConstants.PROPERTY_RESULT = "result";
SlingoConstants.PROPERTY_BOUND = "bound";
SlingoConstants.PROPERTY_WEIGHT = "weight";
SlingoConstants.PROPERTY_IS_WIN = "isWin";
// Express mechanic specific constants
SlingoConstants.PROPERTY_JOKER_STORED = "jokerStored";
SlingoConstants.PROPERTY_SUPER_JOKER_STORED = "superJokerStored";
SlingoConstants.PROPERTY_PREVIOUS_JOKER_STORED = "previousJokerStored";
SlingoConstants.PROPERTY_PREVIOUS_SUPER_JOKER_STORED = "previousSuperJokerStored";
SlingoConstants.PROPERTY_TOTAL_JOKER_STORED = "totalJokerStored";
SlingoConstants.PROPERTY_TOTAL_SUPER_JOKER_STORED = "totalSuperJokerStored";
//# sourceMappingURL=SlingoConstants.js.map